/** Pure focus-transition helper for the public prospect contact widget. */
export function resolveContactWidgetFocusAction({ wasOpen, isOpen }) {
  if (!wasOpen && isOpen) return 'focus-close';
  if (wasOpen && !isOpen) return 'focus-open';
  return 'none';
}
